var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-console */
import Calendar from '@/models/calendar';
import Contact from '@/models/contact';
import Team from '@/models/team';
import User from '@/models/user';
import { CalendarEventService } from '@/service/CalendarEventService';
import { CalendarGroupService } from '@/service/CalendarGroupService';
import { ContactService } from '@/service/ContactService';
import { UserService } from '@/service/UserService';
import { reactive } from 'vue';
const AppState = reactive({
    locationId: '',
    appointmentEditSource: '',
    source: '',
    location: '',
    timezone: 'UTC',
    locale: '',
    selectedCalendarId: '',
    calendars: [],
    globalCalendars: [],
    teams: [],
    isLoading: false,
    users: [],
    calendarPageData: {},
    selectedContact: undefined,
    disableContactTimezone: false,
    shouldAllowCustomTime: false,
    globalSlots: null,
    globalSlotsQuery: null,
    appointmentToBeEdited: '',
    isRecurringEnabled: false,
    receivedData: {},
    loggedInUserDetail: null,
    user: null,
    isNewEvent: false,
    isNewBlockSlot: false,
    contacts: [],
    webinarDetail: null,
    isEdit: false,
    isCalendarEvent: false,
    router: {},
    showBlockedTimeAndContact: true,
});
export const setInitialValues = (data) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    AppState.receivedData = data;
    AppState.locale = data.locale;
    AppState.source = data.source;
    AppState.appointmentEditSource = data.source;
    AppState.locationId = data.locationId;
    AppState.location = data.location;
    AppState.timezone = data.timeZone;
    AppState.isNewBlockSlot = (data === null || data === void 0 ? void 0 : data.isNewBlockSlot) || false;
    AppState.isNewEvent = (data === null || data === void 0 ? void 0 : data.isNewEvent) || false;
    AppState.isCalendarEvent = (_a = data === null || data === void 0 ? void 0 : data.isCalendarEvent) !== null && _a !== void 0 ? _a : false;
    AppState.disableContactTimezone = (_b = data === null || data === void 0 ? void 0 : data.disableContactTimezone) !== null && _b !== void 0 ? _b : false;
    AppState.isRecurringEnabled = (data === null || data === void 0 ? void 0 : data.recurringEventsEnabled) || false;
    AppState.showBlockedTimeAndContact = (_c = data === null || data === void 0 ? void 0 : data.showBlockedTimeAndContact) !== null && _c !== void 0 ? _c : true;
    AppState.loggedInUserDetail = new User(data === null || data === void 0 ? void 0 : data.loggedInUserInfo);
    setInitialData(data);
    AppState.user = {
        id: (data === null || data === void 0 ? void 0 : data.userId) || '',
        type: (data === null || data === void 0 ? void 0 : data.userType) || '',
        role: (data === null || data === void 0 ? void 0 : data.userRole) || '',
        version: 1,
    };
    if (AppState.isEdit) {
        AppState.appointmentToBeEdited = (_d = data === null || data === void 0 ? void 0 : data.eventId) !== null && _d !== void 0 ? _d : '';
        if (!AppState.isNewBlockSlot) {
            AppState.webinarDetail = data;
        }
        AppState.shouldAllowCustomTime = true;
    }
    else {
        AppState.calendarPageData = {
            startTime: data.startTime,
            endTime: data.endTime,
            calendarId: data.calendarId,
            isUserCalendar: data.isUserCalendar,
            userId: data.userId,
            calendarProviderId: data.calendarProviderId,
            version: data.isV2CalendarSelected ? 2 : 3,
        };
        if (AppState.isNewBlockSlot || AppState.isCalendarEvent)
            AppState.shouldAllowCustomTime = true;
    }
    if (data.contactId) {
        yield getContactDetails(data.contactId);
    }
});
const setInitialData = (data) => {
    const calendarsData = data.calendars.map((calendar) => new Calendar(calendar));
    AppState.globalCalendars = calendarsData;
    AppState.calendars = calendarsData;
    const teamsData = data.groups.map((team) => new Team(team));
    AppState.teams = teamsData;
    const usersData = data.users.map((user) => new User(user));
    AppState.users = usersData;
};
export const setGlobalSlotsAndQuery = (globalSlots, globalSlotsQuery) => {
    AppState.globalSlots = globalSlots;
    AppState.globalSlotsQuery = globalSlotsQuery;
};
export const setLocationId = (id) => {
    AppState.locationId = id;
};
export const getCalendars = () => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield CalendarEventService.getAll(AppState.locationId);
    const calendarsData = data.calendars.map((calendar) => new Calendar(calendar));
    AppState.globalCalendars = calendarsData;
    AppState.calendars = calendarsData;
});
export const getTeams = () => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield CalendarGroupService.getAll(AppState.locationId);
    const teamsData = data.groups.map((team) => new Team(team));
    AppState.teams = teamsData;
});
export const getUsers = () => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield UserService.getAll(AppState.locationId);
    const usersData = data.users.map((user) => new User(user));
    AppState.users = usersData;
});
export const fetchInititalData = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!AppState.isEdit) {
        yield Promise.all([getContacts()]);
    }
});
export const getContacts = () => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield ContactService.searchByName(AppState.locationId, '');
    const contacts = data.contacts.map((contact) => {
        return new Contact(contact);
    });
    let contactsWithName = contacts.filter((contact) => { var _a; return (_a = contact.name) === null || _a === void 0 ? void 0 : _a.trim(); });
    const contactsWithoutName = contacts.filter((contact) => { var _a; return !((_a = contact.name) === null || _a === void 0 ? void 0 : _a.trim()); });
    contactsWithName = contactsWithName.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });
    const contactsData = [...contactsWithName, ...contactsWithoutName];
    AppState.contacts = contactsData;
});
export const getContactDetails = (contactId) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield ContactService.getContactDetails(contactId);
    AppState.selectedContact = new Contact(data.contact);
});
export const resetAppState = () => {
    AppState.locationId = '';
    AppState.source = '';
    AppState.appointmentEditSource = '';
    AppState.location = '';
    AppState.timezone = 'UTC';
    AppState.locale = '';
    AppState.selectedCalendarId = '';
    AppState.calendars = [];
    AppState.teams = [];
    AppState.isLoading = false;
    AppState.users = [];
    AppState.calendarPageData = {};
    AppState.selectedContact = undefined;
    AppState.disableContactTimezone = false;
    AppState.shouldAllowCustomTime = false;
    AppState.globalSlots = null;
    AppState.globalSlotsQuery = null;
    AppState.appointmentToBeEdited = '';
    AppState.isRecurringEnabled = false;
    AppState.receivedData = {};
    AppState.loggedInUserDetail = null;
    AppState.user = null;
    AppState.isNewEvent = false;
    AppState.isNewBlockSlot = false;
    AppState.contacts = [];
    AppState.webinarDetail = null;
    AppState.isEdit = false;
    AppState.isCalendarEvent = false;
    AppState.globalCalendars = [];
    AppState.showBlockedTimeAndContact = false;
    AppState.loggedInUserDetail = null;
};
export default AppState;
